module.exports = __webpack_public_path__ + "media/images/bg/left_bg@2x-61021d56fdd3b0c8f116c91ed7ae2737.jpg";